import { api } from "./dataService";

export const fetchGlobalSettings = async () => {
    return await api(`/api/v1/global/settings`);
}